// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"458":"ccd34592","6452":"a13dfd70","6850":"ebaf9144","6942":"5cfc4fb9","9337":"ccd34592"}[chunkId] + ".chunk.css";
};